module.exports = __webpack_public_path__ + "static/media/fcz.5816bc73.jpeg";